/**
 * Einzige Definition der Zeitschaltuhr-Komponententypen im Frontend inkl. Reihenfolge und Farbe.
 * Die Schlüssel entsprechen exakt dem Wire-Contract des Backends (TimerComponentType-Enum:
 * AQ, MQ, Blinker, DO, DI). Bei Änderungen beide Seiten anpassen.
 */
export const TIMER_COMPONENT_TYPES = ['AQ', 'MQ', 'Blinker', 'DO', 'DI'] as const;
export type TimerComponentType = typeof TIMER_COMPONENT_TYPES[number];

export interface TimerTypeStyle {
  color: string;
  text: string;
}

export const TIMER_TYPE_STYLE: Record<string, TimerTypeStyle> = {
  AQ: { color: '#2f6df6', text: '#ffffff' },
  MQ: { color: '#0f9d8f', text: '#ffffff' },
  Blinker: { color: '#f5a300', text: '#3a2600' },
  DO: { color: '#7a5af8', text: '#ffffff' },
  DI: { color: '#5b6472', text: '#ffffff' }
};

export function timerTypeStyle(type: string): TimerTypeStyle {
  return TIMER_TYPE_STYLE[type] ?? { color: '#888888', text: '#ffffff' };
}

/** Gegebene Typen in kanonischer Reihenfolge als Blöcke mit Farbe. */
export function timerTypeBlocks(types: string[]): { label: string, color: string, text: string }[] {
  return TIMER_COMPONENT_TYPES
    .filter(t => types.includes(t))
    .map(t => ({ label: t, color: TIMER_TYPE_STYLE[t].color, text: TIMER_TYPE_STYLE[t].text }));
}

/** Zuordnung der Zeitleisten-Lane-Schlüssel (klein) zu den kanonischen Typen. */
export const LANE_KEY_TO_TYPE: Record<string, TimerComponentType> = {
  aq: 'AQ', mq: 'MQ', blinker: 'Blinker', do: 'DO', di: 'DI'
};

/** Farbe einer Lane (kleiner Lane-Schlüssel) aus der zentralen Typdefinition. */
export function laneColorHex(laneKey: string): string {
  const type = LANE_KEY_TO_TYPE[laneKey];
  return type ? TIMER_TYPE_STYLE[type].color : '#888888';
}
